/*
 * @Author: HuXiangYu
 * @Date: 2022-10-19 10:25:11
 * @Last Modified by: HuXiangYu
 * @Last Modified time: 2022-10-31 14:35:17
 */

/**
 * 业务表单渲染
 * 一. 场景1--普通表单
 * 1.新增状态下 获取 v-form-render 的 formData，并通过处理提交给新增接口。
 * 2.更新状态下 通过根据ID获取表单数据接口获取到数据后，通过setFormData方法回显数据。
 * 3.查看状态下 不显示表单的提交按钮。
 *
 *
 *  */
export default {
	data() {
		return {
           
            type:'add', //表单类型  分为add 新增、edit 编辑、view 查看 
            title:" ",   //标题
			loading: false,
			/* 注意：formJson是指表单设计器导出的json，此处演示的formJson只是一个空白表单json！！ */
			formJson: null,
			formConfig: {},
            readOnly:false,  //全局状态的只读
			formData: {
				tableName: '', //表名
				cols: [
					// {
					//     colName: 'ID',   //列名
					//     subName: 'id',   //字段名
					//     value: '3B6CE978F68E11EC9DDF10E7C63A3BA4',   //值
					//     type: 'Varchar', //数据库字段类型
					// }
				],
			},
		}
	},
	props: {
		//code 用于获取表单模型数据
		code: {
			type: String,
		},
	},
	methods: {
        //获取表单数据
        async getFormData(id,tableName="") {
            this.loading = true
            let res = await this.$http({
                method: 'post',
                url: this.$http.adornWorkFlowUrl(
                    `modelData/getFormDataById`
                ),
                // url:'/modelData/insertData',
                data: {
                    tableName: tableName?tableName:this.formConfig.tableName,
                    idValue:id
                },
            })
            let {data} = res
            console.log('获取到的数据',data)
            if(data.code===40000){
                //data.instance
                this.$refs.vFormRef.setFormData(data.instance)

            }
            this.loading = false
            
        },
		/**
		 *
		 * @param {string} code
		 */
		async getModelInfo(code,callback) {
			this.show = true
			this.loading = true
			if (!code)  {
				this.$alert(
					'表单缺乏必要参数【code】,请联系管理员。',
					'错误提示'
				)
				console.info(
					`%cAceFormRender`,
					[
						'color:#ea3838',
						'background:rgba(247,137,137,0.2)',
						'font-size:12px',
						'border:1px solid #ea3838',
						'padding:2px',
					].join(';'),
					`需要传入code（）`
				)
                return
			}
			let result = await this.$http({
				url: this.$http.adornUrl(
					`/sysModelForms/query/formChart/byCode?code=${code}`
				),
				method: 'get',
			})
			if (result.data.code === 40000) {
				//给表单对象赋值：如果请求到的数据里有formChart属性，则赋值请求到的数据，否则赋值基础数据
				this.formConfig = result.data.instance
				this.formJson = JSON.parse(this.formConfig.formChart)
				this.$refs.vFormRef.setFormJson(this.formJson)
				this.formData.tableName = this.formConfig.tableName
                callback && callback()
				//将tableName 赋值给form
				// this.$notify({
				// 	message: '数据加载成功',
				// 	type: 'success',
				// })
			} else {
				this.$notify.error({
					title: '错误',
					message: result.data.msg,
				})
			}
            this.$nextTick(()=>{
                //重置所有数据
                this.$refs.vFormRef.resetForm()
            })
			this.loading = false
		},
	},
}
